<div [class]="'pr-toolbar ' + clazz">
  <ng-content></ng-content>
</div>
